import React from "react"
import styled from "styled-components"
import { color } from "../../../configs/utilities"
import { Link } from "gatsby"
import AccordionMobileNavbar from "../../common/accordions/AccordionMobileNavbar"
import { useLocation } from "@reach/router"
import logo from "../../../assets/navbar/logo.svg"
import facebook from "../../../assets/navbar/facebook.svg"
import instagram from "../../../assets/navbar/instagram.svg"
import linkedin from "../../../assets/navbar/linkedin.svg"
import twitter from "../../../assets/navbar/twitter.svg"
import ButtonLink from "../../common/buttons/ButtonLink"

const NavItemsMobile = ({ data, toggleNav }) => {
  const location = useLocation().pathname.split("/").pop()

  return (
    <NavItemsMobileWrapper>
      <SocialNetworks onClick={toggleNav}>
        <a
          href="https://www.facebook.com/"
          target="_blank"
          rel="noopener noreferrer"
          onClick={toggleNav}
        >
          <img src={facebook} alt="facebook" />
        </a>
        <a
          href="https://www.instagram.com/"
          target="_blank"
          rel="noopener noreferrer"
          onClick={toggleNav}
        >
          <img src={instagram} alt="instagram" />
        </a>
        <a
          href="https://www.linkedin.com/"
          target="_blank"
          rel="noopener noreferrer"
          onClick={toggleNav}
        >
          <img src={linkedin} alt="linkedin" />
        </a>
        <a
          href="https://twitter.com/"
          target="_blank"
          rel="noopener noreferrer"
          onClick={toggleNav}
        >
          <img src={twitter} alt="twitter" />
        </a>
      </SocialNetworks>
      <MobileLinksWrapper>
        {data.map((item, index) => {
          return (
            <div key={index}>
              {!item.node.isSubmenu ? (
                <NavbarItem>
                  <Link to={item.node.path} activeClassName="activeNavbarLink">
                    {item.node.text}
                  </Link>
                </NavbarItem>
              ) : (
                <NavbarItem>
                  <AccordionMobileNavbar
                    id={index}
                    head={item.node.text}
                    partiallyActive
                    activeClassName={
                      item.node.submenu.some(item => {
                        return item.path.includes(location)
                      }) && location !== ""
                        ? "activeNavbarLink"
                        : ""
                    }
                    text={
                      <AccordionMobileSubmenu>
                        {item.node.submenu.map((item, index) => {
                          return (
                            <AccordionSubmenuLinksWrapper key={index}>
                              {item.path.includes("https") ? (
                                <a
                                  href={item.path}
                                  target="_self"
                                  rel="noopener noreferrer"
                                >
                                  {item.text}
                                </a>
                              ) : (
                                <Link
                                  to={item.path}
                                  partiallyActive
                                  activeClassName="activeNavbarLink"
                                >
                                  {item.text}
                                </Link>
                              )}
                            </AccordionSubmenuLinksWrapper>
                          )
                        })}
                      </AccordionMobileSubmenu>
                    }
                  />
                </NavbarItem>
              )}
            </div>
          )
        })}
        <AddMoverWrapper>
          <ButtonLink
            to="/add-mover"
            buttonText="Add mover"
            buttonBackground={color.yellow}
            buttonTextColor={color.blue}
          />
        </AddMoverWrapper>
      </MobileLinksWrapper>
      <LogoWrapper>
        <Link to="/" onClick={toggleNav}>
          <img src={logo} alt="navbar logo" />
        </Link>
      </LogoWrapper>
    </NavItemsMobileWrapper>
  )
}

export default NavItemsMobile

const NavItemsMobileWrapper = styled.div`
  width: 80vw;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  font-size: 18px;
  font-weight: 400;
  color: ${color.black};

  /* --------------------------  ACTIVE --------------------------- */
  .activeNavbarLink {
    color: ${color.black};
    font-weight: 600;

    &:after {
      content: "";
      display: block;
      position: absolute;
      width: 100%;
      height: 2px;
      top: 55px;
      left: 0;
      background-color: ${color.black};
    }
  }
`

const MobileLinksWrapper = styled.div`
  width: 100%;
  height: 60vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  text-align: center;
  overflow: auto;

  a {
    color: ${color.black};
  }
`

const NavbarItem = styled.div`
  position: relative;
  padding: 15px 0;
`

const AccordionMobileSubmenu = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 30px;
  row-gap: 20px;
`

const AccordionSubmenuLinksWrapper = styled.div`
  display: flex;
  justify-content: center;

  a {
    margin: 10px 0;
    font-size: 18px;
    color: ${color.black};
    font-weight: 400;
  }

  .activeNavbarLink {
    color: ${color.black};
  }
`

const AddMoverWrapper = styled.div`
  margin-top: 30px;
`

const SocialNetworks = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  column-gap: 30px;
`

const LogoWrapper = styled.div`
  img {
    width: 100%;
    max-width: 200px;
  }
`
